import { InjectionToken } from '@angular/core';
import { EnumCatalogueEntryResponseDto } from 'src/app/shared/data/dto/enum-catalogue/enum-catalogue-entry-response-dto.model';

/** Catalogue entries `EnumCatalogueService` starts with before any load; the app provides none. */
export const ENUM_CATALOGUE_ENTRIES = new InjectionToken<readonly EnumCatalogueEntryResponseDto[]>(
	'ENUM_CATALOGUE_ENTRIES'
);
